import React from 'react';
import { defaultTemplate } from 'core/hoc';

const UnauthorizedTemplate = ({ routerStore, t }) => {
	return (
		<div className="page-404">
			<div className="w--400--px align--h--center type--center ">
				<img className="display--b spc--bottom--med" src={require('themes/img/es-roles.svg')} />
				<p className="spc--bottom--med w--250--px align--h--center">{t('NOTAUTHORIZED')}</p>
				<a className="btn btn--med btn--primary" onClick={() => routerStore.goTo('master.app.membership.login')}>
					{t('GOBACKTOLOGIN')}
				</a>
			</div>
		</div>
	);
};

export default defaultTemplate(UnauthorizedTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/membership/pages/UnauthorizedTemplate.jsx